// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__8cmVa","header":"Pay_header__9VVet","goBack":"Pay_goBack__K-wVN","container":"Pay_container__bAWOa"};